import React, { Component, Fragment } from "react";
import './style.css';
import api from "../../../services/api";
import FormMetasMensais from "./FormMetasMensais";
import FormMetasMensaisContainer from "./FormMetasMensaisContainer";

/**
 * Componente responsável pelo preenchimento das metas mensais de um cursos
 */

export default class MetasMensais extends Component {

    constructor(props) {
        super(props);

        // Define o estado incial da aplicação
        this.state = {
            titulo: "Metas Mensais",
            unidade: this.props.unidade.toUpperCase(),
            curso: "",
            meses: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            metas: {
                mes: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                numTurmas: [],
                numAlunosTurmas: [],
                cargaHoraria: [],
                numMatriculasResiduais: [],
                numMatriculasNovas: [],
                numTotalMatriculas: [],
                horaAluno: [],
                cargaHorariaTurmaAno: [],
                necessidadeDocente8H: [],
                necessidadeDocente7H: [],
                horaAlunoDistribuida: [],
                dataInicio: [],
                dataFim: [],
                total: []
            }
        }
    }

    async componentDidMount() {
        await this.loadMetas();
    }

    // Método para carregar as meta do curso selecionado
    loadMetas = async () => {
        let metas = await api.get("/metas");
        metas = metas.data.metas.filter(meta => this.props.idmeta === meta._id);
        
        this.setState({
            curso: metas.length > 0 ? metas[0].curso : "-",
            metas: metas.length > 0 ? metas[0].metasMensais : []
        });
    }

    // Método que recebe os dados do formulário e envia os dados formatados para o endpoint da API
    onSubmit = async (event) => {
        event.preventDefault();

        let metasMensais = {
            mes: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
            numTurmas: [],
            numAlunosTurmas: [],
            cargaHoraria: [],
            numMatriculasResiduais: [],
            numMatriculasNovas: [],
            numTotalMatriculas: [],
            horaAluno: [],
            cargaHorariaTurmaAno: [],
            necessidadeDocente8H: [],
            necessidadeDocente7H: [],
            horaAlunoDistribuida: [],
            dataInicio: [],
            dataFim: [],
            total: []
        }

        event.target.numTurmas.forEach(el => metasMensais.numTurmas.push(Number.parseFloat(el.value) || 0));
        event.target.numAlunosTurmas.forEach(el => metasMensais.numAlunosTurmas.push(Number.parseFloat(el.value) || 0));
        event.target.cargaHoraria.forEach(el => metasMensais.cargaHoraria.push(Number.parseFloat(el.value) || 0));
        event.target.numMatriculasResiduais.forEach(el => metasMensais.numMatriculasResiduais.push(Number.parseFloat(el.value) || 0));
        event.target.numMatriculasNovas.forEach(el => metasMensais.numMatriculasNovas.push(Number.parseFloat(el.value) || 0));
        event.target.numTotalMatriculas.forEach(el => metasMensais.numTotalMatriculas.push(Number.parseFloat(el.value) || 0));
        event.target.horaAluno.forEach(el => metasMensais.horaAluno.push(Number.parseFloat(el.value) || 0));
        event.target.cargaHorariaTurmaAno.forEach(el => metasMensais.cargaHorariaTurmaAno.push(Number.parseFloat(el.value) || 0));
        event.target.necessidadeDocente8H.forEach(el => metasMensais.necessidadeDocente8H.push(Number.parseFloat(el.value) || 0));
        event.target.necessidadeDocente7H.forEach(el => metasMensais.necessidadeDocente7H.push(Number.parseFloat(el.value) || 0));
        event.target.horaAlunoDistribuida.forEach(el => metasMensais.horaAlunoDistribuida.push(Number.parseFloat(el.value) || 0));
        event.target.dataInicio.forEach(el => metasMensais.dataInicio.push(el.value));
        event.target.dataFim.forEach(el => metasMensais.dataFim.push(el.value));

        let total = [
            event.target.totalNumTurmas.value,
            event.target.totalNumAlunosTurmas.value,
            event.target.totalCargaHoraria.value,
            event.target.totalNumMatriculasResiduais.value,
            event.target.totalNumMatriculasNovas.value,
            event.target.totalNumTotalMatriculas.value,
            event.target.totalHoraAluno.value,
            event.target.totalCargaHorariaTurmaAno.value,
            event.target.totalNecessidadeDocente8H.value,
            event.target.totalNecessidadeDocente7H.value,
            event.target.totalHoraAlunoDistribuida.value,
        ]

        metasMensais.total = total.map(valor => Number.parseFloat(valor));
        let status = await api.put(`/metas/${this.props.idmeta}`, metasMensais);
        if(status.data.status === "ok") window.showNotification('Cadastrado com sucesso', 'success');
        else window.showNotification(status.data.status || 'Erro na atualização', 'danger');
    }

    render() {
        return (
            <FormMetasMensaisContainer
                metas={this.state.metas}
                meses={this.state.meses}
                onSubmit={this.onSubmit}
                unidade={this.props.unidade}
                curso={this.state.curso}
            />
        )
    }
}